import type { ReactNode } from 'react';

export const symbol_lunch_dining: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-120q-25 0-42.5-17.5T80-180v-98q0-13 8.5-21.5T110-308h740q13 0 21.5 8.5T880-278v98q0 25-17.5 42.5T820-120H140Zm0-128v68h680v-68H140Zm279.5-156Q400-382 346-382t-71.5-22Q257-426 216-426q-34 0-52.5 16.5T110-385q-12 2-21-6t-9-21q0-13 9-22.5t21-14.5q21-9 43-23t63-14q54 0 71.5 22t58.5 22q41 0 60.5-22t73.5-22q54 0 73.5 22t60.5 22q41 0 58.5-22t71.5-22q41 0 63 14t43 23q12 5 21 14.5t9 22.5q0 13-9 21t-21 6q-35-8-53.5-24.5T744-426q-41 0-58.5 22T614-382q-54 0-73.5-22T480-426q-41 0-60.5 22ZM626-825q72 15 128.5 46t91 78.5Q880-653 880-588q0 13-8.5 21.5T850-558H110q-13 0-21.5-8.5T80-588q0-65 34.5-112.5t91-78.5Q262-810 334-825t146-15q74 0 146 15Zm-146 45q-148 0-242.5 46.5T142-618h676q-3-69-96.5-115.5T480-780Zm0 532Zm0-370Z"
		/>
	</svg>
);
